import { faCheck, faXmark } from '@fortawesome/pro-regular-svg-icons';

import { CARD_TYPES } from 'src/features/cards/types';
import { generalMessages } from 'src/utils/messages';

import type { BadgeOptions, BadgeOption } from 'src/types/ui';

const canNotBeValidated: BadgeOption = {
    theme: 'red',
    label: generalMessages.no,
    icon: faXmark,
};

export const badgeValidationOptions: BadgeOptions = {
    [`${CARD_TYPES.NORMAL}-true`]: {
        theme: 'red',
        label: generalMessages.no,
        icon: faXmark,
    },
    [`${CARD_TYPES.NORMAL}-false`]: {
        theme: 'green',
        label: generalMessages.yes,
        icon: faCheck,
    },
    [`${CARD_TYPES.NORMAL}-null`]: {
        theme: 'green',
        label: generalMessages.yes,
        icon: faCheck,
    },
    [`${CARD_TYPES.VIP}-true`]: canNotBeValidated,
    [`${CARD_TYPES.VIP}-false`]: canNotBeValidated,
    [`${CARD_TYPES.VIP}-null`]: canNotBeValidated,
    [`${CARD_TYPES.MEMBERSHIP}-true`]: canNotBeValidated,
    [`${CARD_TYPES.MEMBERSHIP}-false`]: canNotBeValidated,
    [`${CARD_TYPES.MEMBERSHIP}-null`]: canNotBeValidated,
    [`${CARD_TYPES.OPERATOR}-true`]: canNotBeValidated,
    [`${CARD_TYPES.OPERATOR}-false`]: canNotBeValidated,
    [`${CARD_TYPES.OPERATOR}-null`]: canNotBeValidated,
    [`${CARD_TYPES.PREPAID}-true`]: canNotBeValidated,
    [`${CARD_TYPES.PREPAID}-false`]: canNotBeValidated,
    [`${CARD_TYPES.PREPAID}-null`]: canNotBeValidated,
    [`${CARD_TYPES.PREPAID_S}-true`]: canNotBeValidated,
    [`${CARD_TYPES.PREPAID_S}-false`]: canNotBeValidated,
    [`${CARD_TYPES.PREPAID_S}-null`]: canNotBeValidated,
    [`${CARD_TYPES.SERVICE}-true`]: canNotBeValidated,
    [`${CARD_TYPES.SERVICE}-false`]: canNotBeValidated,
    [`${CARD_TYPES.SERVICE}-null`]: canNotBeValidated,
};
